import { useState, useEffect, useRef } from 'react' 
import { useSelector } from 'react-redux'
import YzBackgroundMobile from '../../../../../components/mobile/YzBackgroundMobile'
import AUBCompanyMobile from '../AUBCompanyMobile'
import AUBAdvantageMobile from '../AUBAdvantageMobile'
import AUBTeamMobile from '../AUBTeamMobile'
import FooterMobile from '../../../../../components/mobile/FooterMobile'
import BuoyBoxMobile from '../../../../../components/mobile/BuoyBoxMobile'
import './index.less'

const AboutUsBusinessSectionMobile = () => {
  // 菜单
  const menuList = useSelector((state) => state?.Menu?.menuList) // 菜单列表
  const [backgroud] = menuList.filter(f => f.title === '关于我们').map(m => m.son_navigation.filter(ff => ff.name === '业务布局').map(mm => mm.backgroud))

  // 置顶
  const boxRef = useRef(null)
  const [scrollTop, setScrollTop] = useState(0)
  const [clientHeight, setClientHeight] = useState(0)
  const goToTop = () => { // 置顶事件
    let myTimer = setInterval(() => {
      boxRef.current.scrollTop -= 60
      if(boxRef.current.scrollTop<=0){
        boxRef.current.scrollTop = 0
        window.clearInterval(myTimer)
      }
    }, 10)
  }
  useEffect(() => { // 页面滚动
    window.addEventListener("scroll", (e) => {
      setScrollTop(e?.target?.scrollTop)
      setClientHeight(e?.target?.clientHeight);
    }, true)
  }, [])

  return (
    <section ref={boxRef} className='about_us_section_business_m'>
      <div className='about_us_section_business_box_m'>
        <YzBackgroundMobile
          title='Business Distribution'
          content='业务分布'
          backgroundImage={backgroud}
          isShowButton={false}
        />
        <AUBCompanyMobile />
        <AUBAdvantageMobile />
        <AUBTeamMobile />
        <FooterMobile isAbout={false} />
        <BuoyBoxMobile isShowTop={scrollTop > clientHeight} onTop={goToTop} />
      </div>
    </section>
  )
}

export default AboutUsBusinessSectionMobile